import { render, staticRenderFns } from "./list.vue?vue&type=template&id=440a3b4f&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=440a3b4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "440a3b4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('440a3b4f')) {
      api.createRecord('440a3b4f', component.options)
    } else {
      api.reload('440a3b4f', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=440a3b4f&scoped=true&", function () {
      api.rerender('440a3b4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/scenicTutorials/list.vue"
export default component.exports